import { NumberInput, Field } from '../UI';
import PlayerToggle from './PlayerToggle';

/**
 * Тогл «Таймер времени» + поле длительности.
 * Используется в DraftSettings и CreateTournamentPage.
 *
 * @param {string}   matchScoring              — 'TIME' | 'POINTS'
 * @param {Function} onMatchScoringChange      — (newValue) => void
 * @param {number}   matchDurationMinutes
 * @param {Function} onMatchDurationChange     — (newValue) => void
 * @param {string}   [durationError]           — текст ошибки для поля длительности
 * @param {Function} [onDurationErrorClear]    — вызывается при изменении длительности, если ошибка есть
 */
const MatchScoringField = ({
  matchScoring,
  onMatchScoringChange,
  matchDurationMinutes,
  onMatchDurationChange,
  durationError,
  onDurationErrorClear,
}) => (
  <>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>Таймер времени</div>
        <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>
          {matchScoring === 'TIME' ? 'Матч ограничен по времени' : 'Матч идёт до набора очков'}
        </div>
      </div>
      <PlayerToggle
        active={matchScoring === 'TIME'}
        onChange={() => onMatchScoringChange(matchScoring === 'TIME' ? 'POINTS' : 'TIME')}
      />
    </div>

    {matchScoring === 'TIME' && (
      <Field label="Длительность матча (минуты)" error={durationError}>
        <NumberInput
          min={1}
          value={matchDurationMinutes}
          onChange={e => {
            onMatchDurationChange(e.target.value);
            if (durationError && onDurationErrorClear) onDurationErrorClear();
          }}
          error={durationError}
        />
      </Field>
    )}
  </>
);

export default MatchScoringField;
